<template>
  <div class="login">
    <md-field>
      <md-field-item title="国家/地区" arrow="arrow" :addon="registeredPlace"
                     @click="isPickerShow = true">
      </md-field-item>
      <div v-if="countryId">
        <md-input-item ref="input0" v-model="phone" placeholder="請輸入手机号" v-if="isphone"  >
          <div class="codecontaine" slot="left">
            <md-field-item   :addon="'+'+phonecode"
                           @click="isPickerShowphonecode = true">
            </md-field-item>
          </div>
        </md-input-item>
<!--        11-->
        <md-input-item ref="input0" v-model="code" :placeholder="placeholdercode" :maxlength="6" type="digit"
                       v-if="(phonecode==='886'&&checkCountry.registerModel===2)">
          <div class="codecontaine" slot="right">
            <span @click="send" style="color: #097ef7">{{ time }}</span>
          </div>
        </md-input-item>
      <md-input-item ref="input0" v-model="email" placeholder="請輸入郵箱" v-if="isemail"></md-input-item>
      <md-input-item ref="input0" v-model="code" :placeholder="placeholdercode" :maxlength="6" type="digit"
        v-if="checkCountry.registerModel==1">
        <div class="codecontaine" slot="right">
          <span @click="send" style="color: #097ef7">{{ time }}</span>
        </div>
      </md-input-item>
      <md-input-item ref="input0" v-model="userName" placeholder="请输入2~20位用户名" :disabled="checked"
        @change="checkBankuserName">
        <div class="codecontaine" slot="right" v-if="isemail">
          <md-agree v-model="checked" size="md" @change="onChange($event)">
            与邮箱一致
          </md-agree>
        </div>
        <p v-if="isErrorusername" class="error" slot="error">
          请输入2~20位用户名
        </p>
      </md-input-item>
      <md-input-item ref="input0" v-model="passWord" placeholder="請輸入密碼" :maxlength="20"
        :type="showpass ? 'password' : 'text'">
        <md-icon :name="showpass ? 'invisible' : 'visible'" size="lg" slot="right"
          @click="showpass = !showpass"></md-icon>
      </md-input-item>
      </div>
    </md-field>
    <div v-if="countryId">
      <md-button type="warning" round
        style="width: 90%; margin-left: 5%; height: 0.9rem" @click="login">
        <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel"
          :size="15" color="#fff" text-color="#fff"></md-activity-indicator>
        <span v-else>注册</span>
      </md-button>
    </div>

    <md-dialog :closable="false" v-model="iconDialog.open" :btns="iconDialog.btns">
      <span v-if="checkCountry.registerModel===1"> 注册驗證碼已發往您的郵箱，請至郵箱中查看您的郵件</span>
      <span v-if="checkCountry.registerModel===2"> 注册驗證碼已發往您的手机，請至手机短信中查看</span>

    </md-dialog>

    <!-- 国家/地区弹出窗 -->
    <md-selector v-model="isPickerShow" :data="countryList" title="請選擇您要集運的目的地" min-height="100px"
      large-radius :mask-closable="true" class="cheklist" @choose="onSelectorConfirm" is-check>
    </md-selector>
    <md-selector v-model="isPickerShowphonecode" :data="phoneList" title="请选择" min-height="100px"
                 large-radius :mask-closable="true" class="cheklist" @choose="onPhone" is-check>
    </md-selector>
  </div>
</template>

<script>
import {
  ActivityIndicator,
  Agree,
  Button,
  Dialog,
  Field,
  FieldItem,
  Icon,
  InputItem,
  Toast,
  Selector,
} from 'mand-mobile';
import md5 from 'js-md5';
import { isBlank } from '../../../until/common';
import { getUrlKey } from '../../../until/getUrlcode';
export default {
  name: 'RegestModal',
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [FieldItem.name]: FieldItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Agree.name]: Agree,
    [ActivityIndicator.name]: ActivityIndicator,
    [Selector.name]: Selector,
  },
  props: {
    // 店铺参数
    shopkey: {},
  },
  data() {
    return {
      showpass: true,
      showpassold: true,
      isphone:true,
      isemail:true,
       checkCountry:{
         registerModel:1,
         registerModelOption:10
       },
      placeholdercode:'请输入',
      phoneList:[],
      isError: false,
      phone:'',
      isErrorpas: false,
      userName: '',
      isErrorusername: false,
      loading: false,
      checked: false,
      isErrorcode: false,
      passWord: '',
      email: '',
      passWordold: '',
      isclick: false,
      disabled: true,
      time: '獲取驗證碼',
      currentTime: 60,
      isPickerShowphonecode:false,
      iconDialog: {
        open: false,
        btns: [
          {
            text: '確認',
            handler: this.onIconConfirm,
          },
        ],
      },
      isErrorpasold: false,
      code: null,
      isvalue: false,
      // 城市列表
      countryList: [],
      countryId: '',
      registeredPlace: '',
      phonecode:'',
      isPickerShow: false,
    };
  },
  created() {
    this.getCountry();
    this.getMobileCode();
  },
  methods: {
    getMobileCode(){
      this.http.APIASK(this.ports.getMobileCode, 'POST', {}).then((res) => {
       console.log('res',res)
        for (let i in res) {
          res[i].text = res[i].code;
          res[i].label = res[i].code;
          res[i].value = res[i].code;
        }
        this.phonecode=res[0].text
        this.phoneList=res
        // this.countryList = res;
      });
    },
    getCountry() {
      const par = {
        parentId: 0,
      };
      this.http.APIASK(this.ports.country, 'get', par).then((res) => {
        for (let i in res) {
          res[i].text = res[i].name;
          res[i].label = res[i].name;
          res[i].value = res[i].id;
          res[i].registerModel = res[i].registerModel;
          res[i].registerModelOption = res[i].registerModelOption;
        }
        this.countryList = res;
      });
    },
    onPhone({ value, text }){
      this.phonecode = text;
    },
    onSelectorConfirm({ value, text }) {
      this.registeredPlace = text;
      this.countryId = value;
      this.checkCountry=this.countryList.find(val=>{
        return val.value===this.countryId
      })
      if(this.checkCountry.registerModel===1){
        this.placeholdercode='请输入邮箱验证码'
        this.time='获取邮箱验证码'
      }else{
        this.placeholdercode='请输入手机验证码'
        this.time='获取手机验证码'
      }

      if(this.checkCountry.registerModelOption===10){
        this.isphone=false
      }else{
        this.isphone=true
      }
      if(this.checkCountry.registerModelOption===20){
        this.isemail=false
      }else{
        this.isemail=true
      }
      console.log('this.checkCountry',this.checkCountry)
    },
    onChange(event) {
      if(!this.email){
        Toast({ content: '請輸入邮箱', duration: 3000 });
        this.checked=false

      }else{
        var reg = new RegExp(
          '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
        );
        if (!reg.test(this.email.trim())) {
          Toast({ content: '請輸入正确的邮箱地址', duration: 3000 });
          this.checked=false
          return
        }
        if (this.checked) {
          this.userName = '';
          this.isErrorusername = false;
        }
      }

    },
    onIconConfirm() {
      this.iconDialog.open = false;
    },
    sendEmadil(){
      const _this = this;
      if (_this.email && _this.disabled) {
        const par = {
          email: _this.email.trim(),
        };
        par.appCode = this.shopkey.appCode ? this.shopkey.appCode : undefined;
        this.http
          .APIASK(this.ports.sendEmailCode, 'post', par)
          .then((res) => {
            let interval = null;
            let currentTime = _this.currentTime;
            interval = setInterval(function () {
              currentTime--;
              _this.time = currentTime + 'S';
              if (currentTime <= 0) {
                clearInterval(interval);
                if(_this.checkCountry.registerModel===1){
                  _this.time='获取邮箱验证码'
                }else{
                  _this.time='获取手机验证码'
                }
                _this.currentTime = 60;
                _this.disabled = true;
              }
            }, 1000);
            _this.iconDialog.open = true;
            _this.disabled = false;
          })
          .catch((err) => {
            if (err.code == 406) {
              _this.$emit('islogin');
            }
            if(_this.checkCountry.registerModel===1){
              _this.time='获取邮箱验证码'
            }else{
              _this.time='获取手机验证码'
            }
            (_this.currentTime = 60),
              (_this.disabled = true);
          });
      } else if (!_this.email && _this.disabled) {
        Toast({ content: '請輸入emai地址', duration: 3000 });
      } else if (_this.email && !_this.disabled) {
        Toast({ content: '驗證碼已發送', duration: 3000 });
        return false;
      }
    },
    sendPhone(){
      const _this = this;
      if (_this.phone && _this.disabled) {
        const par = {
          "phone": _this.phone,
          "phoneCode": _this.phonecode,
          "shopCode": this.shopkey.appCode ? this.shopkey.appCode : undefined,
        };
        this.http
          .APIASK(this.ports.sendMobileCode, 'post', par)
          .then((res) => {
            let interval = null;
            let currentTime = _this.currentTime;
            interval = setInterval(function () {
              currentTime--;
              _this.time = currentTime + 'S';
              if (currentTime <= 0) {
                clearInterval(interval);
                if(_this.checkCountry.registerModel===1){
                  _this.time='获取邮箱验证码'
                }else{
                  _this.time='获取手机验证码'
                }
                _this.currentTime = 60;
                _this.disabled = true;
              }
            }, 1000);
            _this.iconDialog.open = true;
            _this.disabled = false;
          })
          .catch((err) => {
            if (err.code == 406) {
              _this.$emit('islogin');
            }
            if(_this.checkCountry.registerModel===1){
              _this.time='获取邮箱验证码'
            }else{
              _this.time='获取手机验证码'
            }
            (_this.currentTime = 60),
              (_this.disabled = true);
          });
      } else if (!_this.email && _this.disabled) {
        Toast({ content: '請輸入手机号', duration: 3000 });
      } else if (_this.email && !_this.disabled) {
        Toast({ content: '驗證碼已發送', duration: 3000 });
        return false;
      }
    },
    // 邮箱验证码
    send() {
      if(this.checkCountry.registerModel===1){
        if(!this.email){
          Toast({ content: '請輸入邮箱', duration: 3000 });
          return
        }
        var reg = new RegExp(
          '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
        );
        if (!reg.test(this.email.trim())) {
          Toast({ content: '請輸入正确的邮箱地址', duration: 3000 });
          this.isError = true;
          return
        }
        this.sendEmadil()
      }else{
        if(!this.phone){
          Toast({ content: '請輸入手机号', duration: 3000 });
          return
        }
        this.sendPhone()
      }

    },
    checkBankcode() {
      if (this.code && this.code.length == 6) {
        this.isErrorcode = false;
        this.checkallerr();
      } else {
        this.isErrorcode = true;
      }
    },
    checkBankpassWord() {
      if (this.isNumberOr_Letter(this.passWord)) {
        this.isErrorpas = false;
        this.checkallerr();
      } else {
        this.isErrorpas = true;
        if (this.passWordold) {
          this.checkBankpassWordold();
        }
      }
    },
    isNumberOr_Letter(s) {
      var regu = '^(?=.*\\d)(?=.*[a-z])[a-zA-Z\\d]{6,20}$';
      var re = new RegExp(regu);
      if (re.test(s)) {
        return true;
      } else {
        return false;
      }
    },
    checkBankpassWordold() {
      if (this.passWord != this.passWordold) {
        this.isErrorpasold = true;
      } else {
        this.isErrorpasold = false;
        this.checkallerr();
      }
    },
    checkallerr() {
      if (
        !this.isErrorpasold &&
        !this.isError &&
        !this.isErrorpas &&
        !this.isErrorcode
      ) {
        this.isclick = true;
      } else {
        this.isclick = false;
      }
      if (this.passWord && this.passWordold && this.email && this.code) {
        this.isvalue = true;
      } else {
        this.isvalue = false;
      }
    },
    checkBankuserName() {
      if (this.checked) {
        this.userName = '';
        this.isErrorusername = false;
      } else {
        var reg = new RegExp(
          '^(?!(\\d+)$)([a-zA-Z0-9_\\u4e00-\\u9fa5]{2,20})+$'
        );
        if (!reg.test(this.userName.trim())) {
          this.isErrorusername = true;
        } else {
          this.checkallerr();
          this.isErrorusername = false;
        }
      }
    },
    checkBankCard() {
      var reg = new RegExp(
        '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
      );
      if (!reg.test(this.email.trim())) {
        this.isError = true;
      } else {
        this.checkallerr();
        this.isError = false;
      }
    },
    // 注册
    login() {
      if (isBlank(this.countryId) || isBlank(this.registeredPlace)) {
        Toast.failed('请选择国家/地区');
        return false;
      }
      if(this.checkCountry.registerModel===1){
        if(this.checkCountry.registerModelOption===11){
          if (isBlank(this.phone)) {
            Toast.failed('请输入手机号');
            return false;
          }
          if(this.phonecode==='86'){
            var reg = /^1[3456789]\d{9}$/;
            if (!reg.test(this.phone)) {
              Toast.failed('请输入正确的手机号');
              return false;
            }
          }
        }
        if (isBlank(this.email)) {
          Toast.failed('请输入邮箱');
          return false;
        }
        var reg = new RegExp(
          '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
        );
        if (!reg.test(this.email.trim())) {
          Toast({ content: '請輸入正确的邮箱地址', duration: 3000 });
          return false;
        }
        if (isBlank(this.code)) {
          Toast.failed('请输入邮箱验证码');
          return false;
        }

      }
      if(this.checkCountry.registerModel===2){
        if (isBlank(this.phone)) {
          Toast.failed('请输入手机号');
          return false;
        }
        if(this.phonecode==='86'){
          var reg = /^1[3456789]\d{9}$/;
          if (!reg.test(this.phone)) {
            Toast.failed('请输入正确的手机号');
            return false;
          }
        }
        if(this.checkCountry.registerModelOption===21){
          if (isBlank(this.email)) {
            Toast.failed('请输入邮箱');
            return false;
          }
          var reg = new RegExp(
            '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
          );
          if (!reg.test(this.email.trim())) {
            Toast({ content: '請輸入正确的邮箱地址', duration: 3000 });
            return false;
          }
        }
        if(this.phonecode=='886'){
          if (isBlank(this.code)) {
            Toast.failed('请输入手机验证码');
            return false;
          }
        }

      }
      if(!this.isemail){
        if (isBlank(this.userName)){
          Toast.failed('请输入用户名');
          return false;
        }
      }else{
        if(!this.checked){
          if (isBlank(this.userName)){
            Toast.failed('请输入用户名');
            return false;
          }
        }
      }
      if (isBlank(this.passWord)){
        Toast.failed('请输入密码');
        return false;
      }
      var reg1 =/^(?=.*[0-9])(?=.*[A-Za-z])(?=.*[^A-Za-z0-9]).{8,}$/;
      if (!reg1.test(this.passWord)){
        Toast.failed('密码至少8位数字，英文，符号组合而成');
        return false;
      }
      this.loading = true;
      const par = {
        userName: this.checked ? this.email.trim() : this.userName.trim(),
        email: this.email.trim(),
        code: this.code,
        phone:this.phone,
        phoneCode:this.phonecode,
        type:this.checkCountry.registerModel,
        passWord: md5(this.passWord),
        parentCode: getUrlKey('parentCode', window.location.href),
        promotionCode: localStorage.getItem('rqCode')
          ? localStorage.getItem('rqCode')
          : '',
        countryId: this.countryId,
        registeredPlace: this.registeredPlace,
        shopCode: this.shopkey.appCode ? this.shopkey.appCode : undefined,
      };
      this.http
        .APIASK(this.ports.appRegister, 'post', par)
        .then((res) => {
          localStorage.getItem('rqCode')?localStorage.removeItem('rqCode'):null
          if (res.object) {
            localStorage.setItem('couplist', JSON.stringify(res.object));
          }
          localStorage.setItem('mupressMobiltoken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          this.loading = false;
          this.getUserInfo();
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getUserInfo() {
      this.http
        .APIASK(this.ports.getUserInfo, 'get')
        .then((res) => {
          localStorage.setItem('userinfoMobie', JSON.stringify(res));
          this.$emit('getnext');
        })
        .catch((err) => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less">
.logo {
  width: 0.55rem;
  height: auto;
}
.error {
  text-align: left;
}
.dialog-banner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 60%;
    height: auto;
  }
}

.cheklist {
  .md-cell-item-title {
    text-align: left;
  }
}
.codecontaine .md-field-item-content{
  position: relative;
  width: 1rem;
}
.codecontaine .md-field-item-content::after{
  content:'';
  width:0.18rem;
  height:0.18rem;
  border-bottom: 0.025rem solid #858b9c;
  border-right:0.025rem solid #858b9c;
  position: absolute;
  left:0.85rem;
  top:0.34rem;
  transform: rotate(45deg);

}
.codecontaine .md-field-item-content .md-field-item-right{
 position: absolute;
  left: 0;
}
</style>
